import { getArrayItemsRange } from '../helpers';

const Legends = ({ entries, colorScale, legendsNum }) => {
	const sortedPercsArr = entries.sort((a, b) => {
		// Sort by value
		return b[1] < a[1] ? -1 : 1;
	});
	const legendFeats = sortedPercsArr.slice(0, legendsNum);

	return (
		<div className="legend">
			{legendFeats.map(([k, v]) => (
				<div key={`legend-title-${k}`} className="legend-title">
					<span
						className="color"
						style={{ background: colorScale(v) }}
					></span>
					<span className="key">{k}: </span>
					<span className="val">{(v * 100).toFixed(1)}%</span>
				</div>
			))}
		</div>
	);
};
export default Legends;
